export default __webpack_public_path__ + "static/media/favicon.633fbea1.ico";